/* eslint-disable no-unused-vars */
import { yupResolver } from '@hookform/resolvers/yup'
import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { Link, useNavigate } from 'react-router-dom'
import { AlertErrorForm } from '../../components/AlertErrorForm'
import { TypeUser } from '../../components/Auth/TypeUser'
import { InputPassword } from '../../components/InputPassword'
import { useAuth } from '../../hooks/useAuth'
import { useGeneralApp } from '../../hooks/useGeneralApp'
import { schemaLogin } from './schemaLogin'
import bgImage from '../../assets/home/bg5.jpg'
import { authentication } from '../../firebase-config'
import { RecaptchaVerifier, signInWithPhoneNumber } from 'firebase/auth'
import './styles.scss'

export const LoginPage = () => {
  const { login } = useAuth()
  const { setErrorMessage, errorMessage, setIsLoading, isLoading } = useGeneralApp()

  const countryCode = '+52'
  const [phoneNumber, setPhoneNumber] = useState(countryCode)
  const [expandForm, setExpandForm] = useState(false)
  const [OTP, setOTP] = useState('')
  const generateRecaptcha = () => {
    window.recaptchaVerifier = new RecaptchaVerifier('recaptcha-container', {
      size: 'invisible',
      callback: (response) => {}
    }, authentication)
  }

  const requestOTP = (event) => {
    event.preventDefault()
    if (phoneNumber.length >= 12) {
      setExpandForm(true)
      generateRecaptcha()
      signInWithPhoneNumber(authentication, phoneNumber, window.recaptchaVerifier)
        .then((confirmationResult) => {
          window.confirmationResult = confirmationResult
          console.log('OTP sent')
        }).catch((error) => {
          console.log(error)
        })
    }
  }
  const verifyOTP = () => {
    setIsLoading(true)
    if (OTP.length === 6) {
      // verify otp
      window.confirmationResult.confirm(OTP).then((result) => {
        // User signed in successfully.
        login(result.user, setIsLoading, setErrorMessage)
      }).catch((error) => {
        console.log(error)
        setErrorMessage(error.message)
        setIsLoading(false)
      })
    }
  }

  return (
    <>
      <TypeUser/>
      <div className="container p-0 d-md-grid d-flex flex-wrap justify-content-center align-items-center justify-content-xl-start layout-login">
        <div
          className="w-100 align-self-start p-5" style={{ maxWidth: 527 }}>
          <h1 className="text-center text-light">
          {/* text-xl-start  */}
          Regístrate / Inicia sesión
          </h1>
          <p className="text-center pb-3 mb-3 text-light">
          {/* text-xl-start */}
          Descubre los mejores eventos de tu ciudad, con recomendaciones personalizadas sincronizadas con tu biblioteca de música.
          </p>
          <form onSubmit={requestOTP}>
            <div className="row">
              <div className="col-12">
                <div className="position-relative mb-4">
                  <label htmlFor="phoneNumberInput" className="form-label fs-base text-light">
                    Número móvil
                  </label>
                  <input
                    type="tel"
                    id="phoneNumberInput"
                    value={phoneNumber}
                    onChange={(event) => {
                      setPhoneNumber(event.target.value)
                      setExpandForm(false)
                      setErrorMessage(null)
                    }}
                    className="form-control form-control-lg"
                    placeholder='Número de teléfono móvil'
                  />
                </div>
                { expandForm === true
                  ? <>
                    <div className="position-relative mb-4">
                    <label htmlFor="otpInput" className="form-label fs-base text-light">Código de verificación</label>
                      <input
                        type="number"
                        id="otpInput"
                        value={OTP}
                        className="form-control form-control-lg"
                        placeholder='Código de verificación'
                        onChange={(event) => {
                          setOTP(event.target.value)
                        }}
                      />
                    </div>
                    <button
                      type='button'
                      disabled={OTP.length <= 5}
                      className="btn btn-lg btn-primary btn-block mb-3"
                      onClick={(event) => {
                        setErrorMessage(null)
                        verifyOTP(event)
                      }}
                      >
                        {`${isLoading ? 'Validando...' : 'Validar código'}`}
                      </button>
                  </>
                  : null
                }
                <AlertErrorForm messageError={errorMessage} />
                <p className="text-xl-start pb-3 mb-3 text-light">
                    Al registrarte aceptas nuestros <Link to="terminos-de-uso" className="">Términos de uso</Link> y <Link to="politica-de-privacidad" className="">Polìtica de privacidad</Link>
                </p>
                {
                  expandForm === false
                    ? <button type="submit" disabled={phoneNumber.length <= 12} className="btn btn-lg btn-primary btn-block mb-3">Solicitar código</button>
                    : null
                }
                  <div id="recaptcha-container"></div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  )
}
